var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.page,{tag:"component",attrs:{"wareId":_vm.wareId,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }